import React from 'react';
import { TabPanel, Text } from "@chakra-ui/react";

const Orders = () => {
    return (
        <TabPanel>
      <Text>Orders</Text>
    </TabPanel>
    );
};

export default Orders;